import { render, staticRenderFns } from "./TrendyolChannelDetail.vue?vue&type=template&id=6bf854c8&scoped=true"
import script from "./TrendyolChannelDetail.vue?vue&type=script&lang=js"
export * from "./TrendyolChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./TrendyolChannelDetail.vue?vue&type=style&index=0&id=6bf854c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf854c8",
  null
  
)

export default component.exports